<template>
  <v-container>
    <v-banner
      :style="
        $vuetify.theme.isDark
          ? 'background-color:#272727'
          : 'background-color:#FFFFCA'
      "
      class="banner"
      v-model="show"
      transition="slide-y-transition"
    >
      <v-icon slot="icon" color="#2196F3"> fas fa-info-circle </v-icon>
      <p
        :class="$vuetify.breakpoint.mdAndDown ? 'pr-6' : ''"
        class="message mb-0"
        v-html="message"
      />
      <template v-slot:actions="{ dismiss }">
        <v-btn
          class="pr-2"
          x-small
          absolute
          top
          icon
          text
          elevation="0"
          color="#D3C189"
          @click="dismiss"
        >
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </template>
    </v-banner>
  </v-container>
</template>

<script>
export default {
  data: () => {
    return {
      show: false,
      message: null,
    };
  },
  methods: {
    getNotificationBannerData() {
      // axios request and conditionals
      let response = true;
      if (response) {
        let message =
          "Bienvenidos a la segunda versión de la CPNU, mucho más ágil y amigable en su interacción. Para ver las nuevas características favor dar click <a target='_Ayuda' href='./manual/novedades.html'>AQUI</a>.";
        this.message = message;
        this.show = true;
      }
    },
  },
  mounted: function () {
    this.getNotificationBannerData();
  },
};
</script>

<style lang="scss" scoped>
.banner {
  border: 0.05rem solid rgba(0, 0, 0, 0.8);
  border-radius: 1rem !important;
  z-index: 5;
}
.message {
  font-size: 0.8rem;
}
.theme--light.v-banner,
.theme--dark.v-banner {
  ::v-deep .v-banner__wrapper {
    border-bottom: none !important;
  }
}
</style>